export const SAVE_ALERT_SUCCESS = 'SAVE_ALERT_SUCCESS';
export const SAVE_ALERT_FAILED = 'SAVE_ALERT_FAILED';
export const SET_ALERT_FORM_ERROR = 'SET_ALERT_FORM_ERROR';
export const RESET_ALERT_FORM_ERROR = 'RESET_ALERT_FORM_ERROR';
export const SET_ALERT_SECTION = 'SET_ALERT_SECTION';
export const CREATE_NEW_USER = 'CREATE_NEW_USER';
export const CREATE_NEW_USER_SUCCESS = 'CREATE_NEW_USER_SUCCESS';
export const CREATE_NEW_USER_FAILED = 'CREATE_NEW_USER_FAILED';



// WEBPACK FOOTER //
// ./app/Alerts/email/actionTypes.js